"use client"

import { Skeleton } from "@/components/ui/skeleton"
import React from "react"

export const CareerSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col gap-5 py-8">
      {[1, 2, 3].map(item => (
        <div key={item} className="pb-5 border-b border-[rgba(0, 0, 0, 0.1)]">
          <div className="grid grid-cols-1 sm:grid-cols-12">
            <div className="col-span-5 sm:pr-[15px] flex flex-col sm:gap-[15px] gap-[5px]">
              <Skeleton className="h-6 w-3/4 mb-[10px] sm:mb-0" />
              {[1, 2, 3, 4].map(detail => (
                <div key={detail} className="flex items-center gap-[10px]">
                  <Skeleton className="w-4 h-4 rounded" />
                  <Skeleton className="h-4 w-32" />
                </div>
              ))}
            </div>
            <div className="col-span-5 sm:px-[15px] mt-5 sm:mt-0 flex gap-[30px] items-center">
              <Skeleton className="w-[100px] h-[100px] rounded-sm" />
              <div className="flex flex-col gap-[15px]">
                <Skeleton className="h-5 w-40" />
                <div className="flex items-center gap-[10px]">
                  <Skeleton className="w-4 h-4 rounded" />
                  <Skeleton className="h-4 w-32" />
                </div>
              </div>
            </div>
            <div className="col-span-2 sm:pl-[15px] mt-5 sm:mt-0 flex items-center">
              <Skeleton className="w-[120px] h-[40px] rounded" />
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}


